"use client";
import React, { useCallback, useState } from "react";
import classnames from "classnames";
import SetLCWithUserInfo from "./SetLCWithUserInfo";
import LiveChat from "./LiveChat";
import { getGlobal } from "@/src/utils";
import { getSiteConfiguration } from "@/src/utils/configUtils";
import { useCommonContext } from "@/src/provider/Common/context";
import {
    UserInfoProvider,
} from "@/src/provider";

interface IProps {}
const ShowChat: React.FC<IProps> = (props) => {
    const [showChat, useShowChat] = useState(true);
    const [unreadMsgNumsFromLc, setUnreadMsgNumsFromLc] = useState(0); // lc数量
    const { host } = useCommonContext();

    const handleChatWindowNumsFromLc = useCallback(() => {
        //打开lc 窗口
        setUnreadMsgNumsFromLc(0);
    }, []);
    const handleMessage = useCallback((data: any) => {
        //接受lc 信息
        //检测用户是否在 lc窗口聊天
        // LC_API.chat_window_minimized() 判断lc 窗口最小化
        // LC_API.chat_running() 检查访问者是否正在与代理聊天
        //判断信息来源
        // api url：https://developers.livechat.com/docs/extending-ui/extending-chat-widget/javascript-api/#on-message
        const { user_type } = data;
        if (
            user_type === "agent" &&
            getGlobal().LC_API.chat_window_minimized() &&
            getGlobal().LC_API.chat_running()
        ) {
            //来自客服的消息
            setUnreadMsgNumsFromLc((prev) => prev + 1);
        }
    }, []);
    return (
        <div className={classnames({ ["hidden"]: !showChat })}>
            <UserInfoProvider>
                <SetLCWithUserInfo />
            </UserInfoProvider>
            <LiveChat
                license={getSiteConfiguration("lcLicense", host)}
                isNew={getSiteConfiguration("useNewChat", host)}
                onChatWindowOpened={handleChatWindowNumsFromLc}
                onMessage={handleMessage}
            />
        </div>
    );
};

export default ShowChat;
